import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const GalleryImage = () => {
    return (
        <div className="product-gallery-image d-flex justify-content-center align-items-center position-relative">
            <div className="price-box position-absolute">
                <div className="title-timer-product d-flex">
                    <div className="text-offer"><span className="txt">پیشنهاد ویژه</span></div>
                    <div className="number-timer">
                        <span className="timer-interval-box"
                              data-time-offer="november 28, 2021 19:37:25">00:00:00</span>
                    </div>
                </div>
            </div>
            <div className="image-zoom">
                <div className="swiper swiper-image-zoom-desktop">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <div className="img-box">
                            <img
                                src="https://saymandigital.com/storage/uploads/2021/10/26/HS5ficL79EKHr8tpQezFeg5POjxinQwLLA95M3Li_medium.webp"
                                alt="img" className="img-fluid img-zoom-event--g"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box">
                                <img
                                    src="https://saymandigital.com/storage/uploads/2021/10/26/x1IVuf3xK26rbAt0XXic5AaDO36T1SMPfvvIMRTL_medium.webp"
                                    alt="img" className="img-fluid img-zoom-event--g"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box">
                                <img
                                    src="https://saymandigital.com/storage/uploads/2021/10/27/WbfVYhaM6JUtvLlQIG3LcPgnNBAdkoR3YGUpHrQk_medium.webp"
                                    alt="img" className="img-fluid img-zoom-event--g"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box">
                                <img
                                    src="https://saymandigital.com/storage/uploads/2021/10/26/HS5ficL79EKHr8tpQezFeg5POjxinQwLLA95M3Li_medium.webp"
                                    alt="img" className="img-fluid img-zoom-event--g"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box">
                                <iframe className="iframe-video"
                                        src="https://www.aparat.com/video/video/embed/videohash/PRWm6/vt/frame"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-swiper-wrapper xp-4 position-absolute">
                <div className="link-products-gallery-prev position-absolute">
                    <IconName name="chevron_left" className="icon"/>
                </div>
                <div className="swiper gallery-swiper-image">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <div className="img-box">
                                <img src="https://saymandigital.com/storage/uploads/2021/10/26/HS5ficL79EKHr8tpQezFeg5POjxinQwLLA95M3Li_medium.webp" alt="img1"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box">
                                <img src="https://saymandigital.com/storage/uploads/2021/10/26/x1IVuf3xK26rbAt0XXic5AaDO36T1SMPfvvIMRTL_medium.webp" alt="img1"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box">
                                <img src="https://saymandigital.com/storage/uploads/2021/10/27/WbfVYhaM6JUtvLlQIG3LcPgnNBAdkoR3YGUpHrQk_medium.webp" alt="img1"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box">
                                <img src="https://saymandigital.com/storage/uploads/2021/10/26/HS5ficL79EKHr8tpQezFeg5POjxinQwLLA95M3Li_medium.webp" alt="img1"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box video-play">
                                <img src="./assets/sample-image/f6ca859b10af45a6074568ec043ddb20.png" alt="img1"/>
                                <IconName name="play" className="icon position-absolute"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box">
                                <img src="./assets/sample-image/image 31.png" alt="img1"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box">
                                <img src="./assets/sample-image/image 31.png" alt="img1"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="link-products-gallery-next position-absolute">
                    <IconName name="chevron_left" className="icon"/>
                </div>
            </div>
        </div>
    );
};

export default GalleryImage;
